module.exports = __webpack_public_path__ + "img/bolt.0adf4951.svg";